export { Codes as CodesTable } from './Codes';
